/** Status płatności — odpowiednik PaymentStatus w BE. */
export enum EPaymentStatus {
  Pending = 0,
  Processing = 1,
  Succeeded = 2,
  Failed = 3,
  Cancelled = 4,
  /** Wymaga uwierzytelnienia 3DS/SCA przez użytkownika. */
  RequiresAction = 5,
  /** Zwrócona (refund). */
  Refunded = 6,
  /** Zakwestionowana (chargeback/dispute). */
  Disputed = 7,
}

export interface IPaymentListItem {
  Id: string;
  Year: number;
  Month: number;
  Amount: number;
  Currency: string;
  Status: EPaymentStatus;
  CreationDate: string;
  PaidAt?: string | null;
  InvoiceId?: string | null;
  IsProrationDelta: boolean;
  Description?: string | null;
  /** Termin (potwierdzenia 3DS / kolejnej próby) — do prezentacji. */
  NextActionAt?: string | null;
  /** client_secret do potwierdzenia 3DS (tylko gdy Status === RequiresAction). */
  RequiresActionClientSecret?: string | null;
}

export interface IPaymentsListView {
  /** Klucz publiczny Stripe — do confirmCardPayment przy potwierdzeniu 3DS. */
  PublishableKey?: string | null;
  /** Id zapisanej karty profilu — wymagane w confirmCardPayment (PI po nieudanym off-session nie ma payment_method). */
  PaymentMethodId?: string | null;
  Items: IPaymentListItem[];
}
